import { trackEvent } from '../tracking/tracking';
import {
  isTraversalLoadedState,
  LoadedComponentIdsAndReferences,
  LoadedState,
} from '@ardoq/api-types';
import { isTruthy } from '@ardoq/common-helpers';
import { groupBy } from 'lodash';

const trackOldVersion = (version: string) => {
  trackEvent('Decoding loaded state with old version', { version });
};

const trackExecutionResult = ({
  componentIds,
  references,
  parentChildReferences,
}: LoadedComponentIdsAndReferences) => {
  trackEvent('Viewpoint builder0 dataset executed', {
    references: references.length + parentChildReferences.length,
    components: componentIds.length,
  });
};

const trackViewpointModeViewExecuted = (
  loadedStates: LoadedState[],
  viewStyle: string | undefined
) => {
  const groupedByType = groupBy(loadedStates, 'type');

  const countByType = Object.keys(groupedByType).reduce<Record<string, number>>(
    (acc, type) => {
      acc[type] = groupedByType[type].length;
      return acc;
    },
    {}
  );

  const viewpointIds = loadedStates
    .filter(loadedState => isTraversalLoadedState(loadedState))
    .map(loadedState => loadedState.traversalId)
    .filter(isTruthy);

  trackEvent('Viewpoint mode0 view executed', {
    datasetCount: loadedStates.length,
    countByType,
    viewpointIds,
    viewStyle,
  });
};

export const loadedStateTracking = {
  trackOldVersion,
  trackExecutionResult,
  trackViewpointModeViewExecuted,
};
